import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TasksStatusCardBase } from '@fi-shared/fi-task-shared/tasks-status/common-code/tasks-status-card-base';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { FiTaskListFilterType } from '@fi-shared/fi-task-shared/fi-task-list-filter-type';
import { FiWrapperTableComponent } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.component';
import { ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Component({
    selector: 'fi-tasks-archived',
    templateUrl: './tasks-archived.component.html',
    styleUrls: ['./tasks-archived.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-tasks-archived' },
    standalone: false,
})
export class TasksArchivedComponent extends TasksStatusCardBase implements OnInit {
    @ViewChild(FiWrapperTableComponent, { static: true }) table: FiWrapperTableComponent<ITask>;

    selectedSideListOption = FiTaskListFilterType.All;

    filterPredicate: (item: ITask, filter) => boolean = (data, filter) => {
        if (this.selectedSideListOption === FiTaskListFilterType.All) return true;
        if (this.selectedSideListOption === FiTaskListFilterType.Completed) return data.IsCompleted;
        if (this.selectedSideListOption === FiTaskListFilterType.InProgress) return !data.IsCompleted;
    };

    sideListOptions: ISideListOptionsItem[];
    isMobilePhone: boolean;

    constructor(
        injector: Injector,
        private detectDeviceService: DetectDevicesService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.isMobilePhone = this.detectDeviceService.isMobilePhone();

        this.sideListOptions = [
            {
                text: this.appTextService.get('task.all_tasks'),
                value: FiTaskListFilterType.All,
            },
            {
                text: this.appTextService.get('common.completed'),
                value: FiTaskListFilterType.Completed,
            },
            {
                text: this.appTextService.get('task.in_progress'), // SWE plural
                value: FiTaskListFilterType.InProgress,
            },
        ];

        this.taskActionItems = [
            {
                title: this.appTextService.get('task.restore_tasks'),
                onClick: () => {
                    const taskIds = this.selectedTaskIds;
                    super
                        .saveTaskArchived(false)
                        .then(() => (this.tasks = this.tasks.filter((task) => taskIds.indexOf(task.Id) === -1)));
                },
            },
            {
                title: this.appTextService.get('common.delete_permanently'),
                onClick: () => {
                    const taskIds = this.selectedTaskIds;
                    super
                        .deleteTasks()
                        .then(() => (this.tasks = this.tasks.filter((task) => taskIds.indexOf(task.Id) === -1)));
                },
            },
        ];
    }

    getCompletedText(item: ITask) {
        return this.appTextService.get(item.IsCompleted ? 'common.completed' : 'common.uncompleted');
    }

    getPrivateText(item: ITask) {
        const isPrivate = this.taskHelperService.isPrivate(item);
        return this.appTextService.get(isPrivate ? 'task.private' : 'task.assigned');
    }

    onSelectedSideListOptionChanged($event: number[]) {
        this.selectedTasks = [];
        this.selectedSideListOption = $event.length ? $event[0] : undefined;
        this.table.triggerFiltering();
    }
}
